import { render, staticRenderFns } from "./pandaBallMerchantMenuList.vue?vue&type=template&id=0c4c7dd7&scoped=true"
import script from "./pandaBallMerchantMenuList.vue?vue&type=script&lang=ts"
export * from "./pandaBallMerchantMenuList.vue?vue&type=script&lang=ts"
import style0 from "./pandaBallMerchantMenuList.vue?vue&type=style&index=0&id=0c4c7dd7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c7dd7",
  null
  
)

export default component.exports